export default __webpack_public_path__ + "svg/powered/fse.svg?ce7cd0e4";